import {createMuiTheme} from "@material-ui/core/styles";

const themeGlobal = createMuiTheme({
  typography: {
    h1: {
      fontFamily: ["Nanum Gothic"]
    },
    h2: {
      fontFamily: ["Nanum Gothic"]
    },
    h3: {
      fontFamily: ["Nanum Gothic"]
    },
    h4: {
      fontFamily: ["Nanum Gothic"]
    },
    h5: {
      fontFamily: ["Nanum Gothic"]
    },
    h6: {
      fontFamily: ["Nanum Gothic"]
    },
    fontFamily: ["Nanum Gothic Coding"]
  },
  palette: {
    primary: {
      main: "#2f3131"
    },
    secondary: {
      main: "#919191"
    }
  }
});

export default themeGlobal;
